"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _hook = require("../../hook");

var css = _interopRequireWildcard(require("./StepInputField.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * StepInputFields allow the user specify a numeric value which must be no less than a given value, and no more than another given value.
 *
 * Note that, per the `StepInputFields` component, the `onCounterChange` event returns the
 * formatted number value used in the text field.
 *
 */
const StepInputFieldComponent = /*#__PURE__*/React.forwardRef(({
  disabled = false,
  disablePlusQuantity = false,
  disableMinusQuantity = false,
  isControlled = false,
  controlledResult,
  title = '',
  digitsAfterDot = 2,
  quantity = 1,
  min = 1,
  max,
  value,
  onCounterChange,
  ...otherProps
}, ref) => {
  const [counter, setCounter] = React.useState(1);
  const [result, setResult] = React.useState(0);
  const rendered = (0, _hook.usePrevious)(true);
  const disabledTitleColor = disabled ? 'disabled.2' : undefined;

  const decreaseCounter = () => {
    if (counter > min) setCounter(prev => prev - 1);
  };

  const increaseCounter = () => {
    if (!max || counter < max) setCounter(prev => prev + 1);
  };

  React.useLayoutEffect(() => {
    setCounter(quantity);
  }, [quantity]);
  React.useLayoutEffect(() => {
    if (onCounterChange && rendered) {
      onCounterChange(counter);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [counter, rendered]);
  React.useLayoutEffect(() => {
    if (!isControlled) setResult(counter * Number(value));
  }, [counter, value, isControlled]);
  return (0, _pragma.createFelaElement)(_.View, _extends({
    flex: true,
    flexDirection: "column",
    gap: "xsmall"
  }, otherProps), title && (0, _pragma.createFelaElement)(_.Text, {
    children: title,
    color: disabledTitleColor,
    variant: "body",
    weight: "bold"
  }), (0, _pragma.createFelaElement)(_.View, {
    ref: ref,
    justifyContent: "space-between",
    alignItems: "center",
    padding: ['small', 'medium'],
    css: css.stepField
  }, (0, _pragma.createFelaElement)(_.ButtonIcon, {
    size: "small",
    disabled: disabled || disableMinusQuantity || counter <= min,
    onClick: decreaseCounter,
    name: "minus-button",
    "aria-label": "minus-button"
  }, (0, _pragma.createFelaElement)(_.RemoveIcon, {
    size: "small",
    color: "interactive.ui.default"
  })), (0, _pragma.createFelaElement)(_.View, {
    css: css.textField
  }, (0, _pragma.createFelaElement)(_.Text, {
    weight: "bold",
    color: disabledTitleColor
  }, counter, "\xA0x\xA0"), (0, _pragma.createFelaElement)(_.Text, {
    color: disabledTitleColor
  }, value, "\xA0=\xA0"), (0, _pragma.createFelaElement)(_.Text, {
    color: disabledTitleColor
  }, isControlled ? controlledResult : +(result + 0.0000000001).toFixed(digitsAfterDot) // It should be done for fixing wellknown Floating Point error in JavaScript
  )), (0, _pragma.createFelaElement)(_.ButtonIcon, {
    size: "small",
    disabled: disabled || disablePlusQuantity || Boolean(max && counter >= max),
    name: "plus-button",
    "aria-label": "plus-button",
    onClick: increaseCounter
  }, (0, _pragma.createFelaElement)(_.AddIcon, {
    color: "interactive.ui.default"
  }))));
});
const StepInputField = /*#__PURE__*/React.memo(StepInputFieldComponent);
StepInputField.displayName = 'StepInputField';
var _default = StepInputField;
exports.default = _default;
//# sourceMappingURL=StepInputField.js.map